export const RESET_CONTRACTS = 'RESET_CONTRACTS'
export const SET_CONTRACTS = 'SET_CONTRACTS'
